import { render, staticRenderFns } from "./CoBrokeringSelection.vue?vue&type=template&id=52e5dba6"
import script from "./CoBrokeringSelection.vue?vue&type=script&lang=js"
export * from "./CoBrokeringSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports